import { render, staticRenderFns } from "./DeviceNotifications.vue?vue&type=template&id=5d965ad1"
import script from "./DeviceNotifications.vue?vue&type=script&lang=js"
export * from "./DeviceNotifications.vue?vue&type=script&lang=js"
import style0 from "./DeviceNotifications.vue?vue&type=style&index=0&id=5d965ad1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports